import axios from "axios";
import { resolve } from "./resolve";
import qs from "qs";
import { encrypt } from "../util/util";
import { reGenerateToken } from "./generic";
// let token = '575e81ac-e2b0-486a-ae6c-9b149fdd6ec0';
let token = (window.userName !== 'null' || window.userName !== null) && window.accountToken
const baseURL = window.base_URL; //'https://apisit.mobily.com.sa/api'
const cem_key = window['CEM_KEY']; //'liCENcCCGpHUsEPHNhySYGXCnmhwzZ'
const lang = window.lang
let errorPage = '/wps/myportal/web/personal/store/error' // window.errorPageURL; (ADD)
let counter = 0;

const createTransactionID = () => {
  let currentDateTime = new Date().toISOString().replace(/-|:|T/gi, '').slice(0, 12);
  return 'POR_' + currentDateTime + '_' + Math.ceil(Math.random() * 100000);
}

const createCorrelationID = () => {
  let currentDateTime = new Date().toISOString().replace(/-|:|T/gi, '').slice(0, 12);
  return 'PORC_' + currentDateTime + '_' + Math.ceil(Math.random() * 100000);
}

let config = {
  api: {
    baseURL: baseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      TransactionId: new Date().getTime(),
      channel: "PORTAL",
      "cem-key": cem_key,
      lang: lang,
    },
  },
};

export const api = axios.create({ ...config.api });

api.interceptors.request.use(
  async (conf) => {
    console.log("token : " + token);
    conf.headers.Authorization = "Bearer " + token;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

api.interceptors.response.use(
  async (response) => {
    if (response.status && response.status === 401) {
      counter++;
      token = await reGenerateToken();
      const { config: oldRequest } = response;
      if (counter < 2) return api.request({ ...oldRequest });
    }

    return response;
  },
  async (error) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

export async function checkUser(user, pass) {
  return await resolve(
    await axios({
      method: "post",
      url: window.CHECK_VALID_USER_URL,
      data: qs.stringify({
        username: encrypt(user),
        password: encrypt(pass),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function login(user, pass) {
  return await fetch(window.loginByUsernameURL, {
    method: "POST",
    redirect: "follow",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key // <-- Specifying the Content-Type
    }),
    // We convert the React state to JSON and send it as the POST body
    body: "username=" + encrypt(user) + "&password=" + encrypt(pass), // <-- Post parameters
  }).then(function (response) {
    console.log("Response:", response);

    if (response.redirected) {
      window.location.href = response.url;
    } else {
      return "Error";
    }
  });
}

// Password creteria 
export function getPasswordCreteria() {
  return new Promise((resolve, reject) => {
    fetch(`${baseURL}/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=user_password_rules_info`, {
      method: 'GET',
      headers: {
        "Content-type": "application/json",
        "cem-key": cem_key
      }
    }).then(res => res.text())
      .then((result) => {
        resolve(result);
      }).catch(err => {
        reject(err)
      });
  })
}

export async function validateOTP(pinCodeValue, mobileValue) {
  return await resolve(
    await axios({
      method: "post",
      url: window.validateOTPURL,
      data: qs.stringify({
        pinCode: encrypt(pinCodeValue),
        mobile: encrypt(mobileValue),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function reSendSMS(mobileNumber, lang) {
  return await resolve(
    axios({
      method: "post",
      url: window.RESEND_SMS_URL,
      data: qs.stringify({
        mobileNumber: encrypt(mobileNumber),
        language: lang,
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function sendSMS(mobileNumber, nationalNumber, lang) {
  return await resolve(
    axios({
      method: "post",
      url: window.SEND_SMS_URL,
      data: qs.stringify({
        mobileNumber: encrypt(mobileNumber),
        nationalId: encrypt(nationalNumber),
        language: lang,
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function validateActivationCode(mobileNumberLine, smsCode) {
  return await resolve(
    axios({
      method: "post",
      url: window.VALIDATE_ACTIVATION_URL,
      data: qs.stringify({
        mobileNumberLine: encrypt(mobileNumberLine),
        smsCode: encrypt(smsCode),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function mobileValidateOTP(
  username,
  password,
  login_source,
  login_extra_para,
  locale,
  emailAddress,
  client_id,
  mobileNumberLine,
  smsCode
) {
  return await fetch(window.validateMobileOTPURL, {
    method: "POST",
    redirect: "follow",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded", // <-- Specifying the Content-Type
      "cem-key": cem_key
    }),
    // We convert the React state to JSON and send it as the POST body
    body:
      "login-form-type=pwd&userName=" +
      encrypt(username) +
      "&password=" +
      encrypt(password) + // <-- Post parameters
      "&login_source=" +
      login_source +
      "&login_extra_para=" +
      login_extra_para +
      "&locale=" +
      locale +
      "&emailAddress=" +
      encrypt(emailAddress) +
      "&client_id=" +
      encrypt(client_id) +
      "&mobileNumberLine=" +
      encrypt(mobileNumberLine) +
      "&smsCode=" +
      encrypt(smsCode),
  }).then(function (response) {
    console.log("Response:", response);

    if (
      response.redirected &&
      response.url.toLowerCase().indexOf("login-page") === -1
    ) {
      localStorage.setItem('loginType', 'ML');
      window.location.href = response.url;
      return response;
    } else {
      return "Error";
    }
  });
}

export async function loginCoorparate() {
  return await fetch(window.loginURL, {
    method: "POST",
    redirect: "follow",
    headers: new Headers({
      "Content-Type": "application/x-www-form-urlencoded", // <-- Specifying the Content-Type
      "cem-key": cem_key
    }),
    // We convert the React state to JSON and send it as the POST body
  }).then(function (response) {
    console.log("Response:", response);

    if (response.redirected) {
      window.location.href = response.url;
    } else {
      return "Error";
    }
  });
}

export async function updatePassword(userName, newPassword) {
  return await resolve(
    axios({
      method: "post",
      url: window.UPDATE_PASSWORD_URL,
      data: qs.stringify({
        userName: encrypt(userName),
        newPassword: encrypt(newPassword),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function checkValidPassword(userName, newPassword) {
  return await resolve(
    axios({
      method: "post",
      url: window.CHECK_VALID_PASSWORD,
      data: qs.stringify({
        username: encrypt(userName),
        password: encrypt(newPassword),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

export async function sendOTP(mobileNumber) {
  return await resolve(
    axios({
      method: "post",
      url: window.SEND_OTP,
      data: qs.stringify({
        defaultNumber: encrypt(mobileNumber),
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded", "cem-key": cem_key },
    }).then((res) => res.data)
  );
}

//Not in Use
export async function updateEmailInfo(email, changeInDetailsFlag) {
  var requestBody;
  if (changeInDetailsFlag === true) {
    requestBody = {
      profile: "Auction",
      info: [
        {
          dataName: "LineEmail",
          dataValue: email
        }
      ]
    };
  }
  else {
    requestBody = {
      profile: "Auction",
      info: []
    };
  }

  return await resolve(
    axios({
      method: "put",
      url: baseURL + "/userprofile/v2/profile",
      data: requestBody,
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token, "cem-key": cem_key, "TransactionId": new Date().getTime(), "lang": lang, "channel": "PORTAL" },
    }).then((res) => res.data));

}

//Profile Enquiry for Auctions
export async function profileEnquiry() {
  return api.get(`${baseURL}/userprofile/v2/profile?ProfileResult=Profile`)
}

//Auction Profile Update API's
export async function updateContactInfo(mobilenumber, username, changeInDetailsFlag) {
  let requestBody;
  if (changeInDetailsFlag === true) {
    requestBody = {
      profile: "Auction",
      info: [
        {
          dataName: "Mobile",
          dataValue: mobilenumber
        },
        {
          dataName: "CustomerName",
          dataValue: username
        }
      ]
    };
  } else {
    requestBody = {
      profile: "Auction",
      info: []
    };
  }

  return api.put(`${baseURL}/userprofile/v2/profile`, requestBody)
}

export async function validateContactUpdate(hashcode, pincode) {
  let requestBody = {
    "hashcode": hashcode,
    "otp": pincode
  }

  return api.put(`${baseURL}/userprofile/v2/profile/confirmcontact`, requestBody)
}

export async function resendActivationCode(hashcode, verification) {
  let requestBody = {
    hashCode: hashcode,
    language: "en",
    otpLength: "4",
    isNumeric: "Y",
    verification: verification
  }

  return api.put(`${baseURL}/utility/v1/otp/resend`, requestBody)
}

export async function getCities() {
  return api.get(`${baseURL}/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=AUCTION_PROFILE_CITIES`)
}

export async function updateEmailAndCity(email, city, changeInDetailsFlag) {
  let requestBody;
  if (changeInDetailsFlag === true) {
    requestBody = {
      profile: "Auction",
      info: [
        {
          dataName: "LineEmail",
          dataValue: email
        },
        {
          dataName: "CustomerCity",
          dataValue: city
        }
      ]
    };
  } else {
    requestBody = {
      profile: "Auction",
      info: []
    };
  }

  return api.put(`${baseURL}/userprofile/v2/profile`, requestBody)
}

export async function validateEmailUpdate(hashcode, pincode) {
  let requestBody = {
    "hashcode": hashcode,
    "otp": pincode
  }
  return api.put(`${baseURL}/userprofile/v1/profile/confirmemail`, requestBody)
}

export async function getNationalities() {
  return api.get(`${baseURL}/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=AUCTION_PROFILE_NATIONALITIES`)
}

export async function updateIdAndNationality(id, nationality) {
  let requestBody = {
    profile: "Auction",
    info: [
      {
        dataName: "IDNumber",
        dataValue: id
      },
      {
        dataName: "Nationality",
        dataValue: nationality
      }
    ]
  }

  return api.put(`${baseURL}/userprofile/v2/profile`, requestBody)
}

// export async function getActiveVoiceLines(idNumber) {
//   let keytype = idNumber.startsWith('1') ? 'Saudi National ID' : 'IQAMA'
//   return api.get(`${baseURL}/userprofile/v1/relatedaccounts?keytype=${keytype}&keyvalue=${idNumber}`)
// }

export async function confirmIdAndNationalityUpdate(hashcode) {
  let requestBody = {
    "hashcode": hashcode
  }
  return api.put(`${baseURL}/userprofile/v1/profile/confirmidandnationality`, requestBody)
}

export async function sendAuctionOtp(msisdn, otpType, san, orderId) {
  let requestBody = {
    "msisdn": msisdn,
    "san": san, 
    "moduleId": "125",
    "language": lang === "ar" ? "Arabic" : "English",
    "otpType": otpType,
    "orderId": orderId, //Check
    "requestorChannelId": "EPOR"
  }
  return api.post(`${baseURL}/utility/v1/mobilyotp/send`, requestBody)
}

export async function validateAuctionOtp(otp, serviceRequestID) {
  let requestBody = {
    "otp": otp,
    "serviceRequestID": serviceRequestID,
    "requestorChannelId": "EPOR"
  }
  return api.put(`${baseURL}/utility/v1/mobilyotp/validate`, requestBody)
}

export async function resendAuctionOtp(serviceRequestID, orderId) {
  let requestBody = {
    "serviceRequestID": serviceRequestID,
    "orderId": orderId,
  }
  return api.put(`${baseURL}/utility/v1/mobilyotp/resend`, requestBody)
}
